import { render, staticRenderFns } from "./withdrawDetail.vue?vue&type=template&id=2cb27db2&scoped=true&"
import script from "./withdrawDetail.vue?vue&type=script&lang=js&"
export * from "./withdrawDetail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawDetail.vue?vue&type=style&index=0&id=2cb27db2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb27db2",
  null
  
)

export default component.exports